import React from 'react';
import { Button, Segment, Modal } from 'semantic-ui-react';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import BaseService from '../../apis/services/BaseService';

// COMMON CSS
import 'react-table/react-table.css';
import 'react-toastify/dist/ReactToastify.css';
import '../../css/ReactTable.css';
import '../../css/CardLayout.css';

// COMMON JS
import 'moment/locale/th';
import '../../utils/moment-thai-year-patch';

const CustomZoom = cssTransition({
  enter: 'Toastify__zoom-enter',
  exit: 'Toastify__zoom-exit',
  duration: 200,
});

class Interceptor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      internalError: null
    };
  }
  
  componentDidMount() {
    BaseService.addInterceptor(this, this.handleError);
  }
  
  componentWillUnmount() {
    BaseService.removeInterceptor(this);
  }
  
  handleError = (errorMessage) => {
    this.setState({ internalError: errorMessage });
  };

  onCloseErrorModal = () => {
    this.setState({ internalError: null });
  };

  render() {
    const {
      internalError
    } = this.state;

    
    return (
      <React.Fragment>
        <Modal
          open={!!internalError}
          onClose={this.onCloseErrorModal}
          content={
            <Segment.Group>
              <Segment inverted color='red'>เกิดข้อผิดพลาด</Segment>
              <Segment raised>
                <div style={{ whiteSpace: 'pre-line' }} > {internalError} </div>
                <Button
                  basic
                  color='red'
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                  }}
                  onClick={this.onCloseErrorModal}
                >
                  ตกลง
                </Button>                                    
              </Segment>
            </Segment.Group>
          }
        />
        <ToastContainer
          transition={CustomZoom}
          position={toast.POSITION.TOP_CENTER}
        />
      </React.Fragment>
    );
  }
}

export default Interceptor;